import styled from "styled-components";

export const ProfileStyle = styled.div`
  margin-inline: 20px;
  padding-block: 50px;
  height: calc(100vh - 110px);
`;

export const ProfileButtonWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: calc(100vw - 40px);
  max-width: calc(425px - 40px);
`;
